import type { BetHistory, Match } from './types'

export const matches: Match[] = [
  {
    id: 'm-ars-che',
    league: 'Premier League',
    time: '18:30',
    dateLabel: 'วันนี้',
    home: 'Arsenal',
    away: 'Chelsea',
    homeCode: 'ARS',
    awayCode: 'CHE',
    status: 'upcoming',
    selections: [
      { id: 'ars-win', label: 'Arsenal ชนะ', shortLabel: 'เจ้าบ้าน', odds: 1.72 },
      { id: 'ars-draw', label: 'เสมอ', shortLabel: 'เสมอ', odds: 3.65 },
      { id: 'che-win', label: 'Chelsea ชนะ', shortLabel: 'ทีมเยือน', odds: 4.2 },
    ],
  },
  {
    id: 'm-bar-atm',
    league: 'La Liga',
    time: '21:00',
    dateLabel: 'วันนี้',
    home: 'Barcelona',
    away: 'Atlético Madrid',
    homeCode: 'BAR',
    awayCode: 'ATM',
    status: 'upcoming',
    selections: [
      { id: 'bar-win', label: 'Barcelona ชนะ', shortLabel: 'เจ้าบ้าน', odds: 1.95 },
      { id: 'bar-draw', label: 'เสมอ', shortLabel: 'เสมอ', odds: 3.25 },
      { id: 'atm-win', label: 'Atlético Madrid ชนะ', shortLabel: 'ทีมเยือน', odds: 3.55 },
    ],
  },
  {
    id: 'm-bay-bvb',
    league: 'Bundesliga',
    time: '23:30',
    dateLabel: 'วันนี้',
    home: 'Bayern Munich',
    away: 'Dortmund',
    homeCode: 'BAY',
    awayCode: 'BVB',
    status: 'live',
    score: { home: 2, away: 1 },
    minute: 67,
    selections: [
      { id: 'bay-win', label: 'Bayern Munich ชนะ', shortLabel: 'เจ้าบ้าน', odds: 1.58 },
      { id: 'bay-draw', label: 'เสมอ', shortLabel: 'เสมอ', odds: 4.05 },
      { id: 'bvb-win', label: 'Dortmund ชนะ', shortLabel: 'ทีมเยือน', odds: 5.1 },
    ],
  },
]

export const initialHistory: BetHistory[] = [
  {
    id: 'BET-240901',
    matchLabel: 'Liverpool vs Manchester City',
    selection: 'Liverpool ชนะ',
    stake: 100,
    payout: 185,
    status: 'ชนะ',
    createdAt: 'เมื่อวาน 20:15',
  },
  {
    id: 'BET-240887',
    matchLabel: 'Real Madrid vs Sevilla',
    selection: 'Real Madrid ชนะ',
    stake: 50,
    payout: 0,
    status: 'แพ้',
    createdAt: '28 ก.ย. 21:40',
  },
]
